module.exports = __webpack_public_path__ + "img/addr-card.6962c286.svg";